<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 26 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.70312 14.8437L9.96777 16.8672C10.3961 17.5525 11.1472 17.9687 11.9553 17.9687H14.0447C14.8528 17.9687 15.6039 17.5525 16.0322 16.8672L17.2969 14.8437M3.01001 9.375H7.83941C8.62305 9.375 9.35485 9.76664 9.78953 10.4187L9.96047 10.6751C10.3952 11.3271 11.1269 11.7187 11.9106 11.7187H14.0894C14.8731 11.7187 15.6048 11.3271 16.0395 10.6751L16.2105 10.4187C16.6452 9.76664 17.3769 9.375 18.1606 9.375H22.99M3.01001 9.375C2.90102 9.64874 2.84375 9.94274 2.84375 10.242V12.5C2.84375 13.7944 3.89308 14.8437 5.1875 14.8437H20.8125C22.1069 14.8437 23.1562 13.7944 23.1562 12.5V10.242C23.1562 9.94274 23.099 9.64875 22.99 9.375M3.01001 9.375C3.10478 9.13699 3.23865 8.91428 3.40799 8.71672L6.82971 4.72471C7.27499 4.20523 7.92502 3.90625 8.60922 3.90625H17.3908C18.075 3.90625 18.725 4.20523 19.1703 4.72471L22.592 8.71672C22.7613 8.91428 22.8952 9.13699 22.99 9.375M5.1875 21.0937H20.8125C22.1069 21.0937 23.1562 20.0444 23.1562 18.75V16.0156C23.1562 15.3684 22.6316 14.8437 21.9844 14.8437H4.01562C3.36842 14.8437 2.84375 15.3684 2.84375 16.0156V18.75C2.84375 20.0444 3.89308 21.0937 5.1875 21.0937Z"
				:stroke="color"
				stroke-width="1.56"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgResources',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
